import React from 'react';
import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'mz-intl'
import {
  UpgradesContainer,
  mapDispatchToProps,
  mapStateToProps,
} from 'app/components/book-trip/UpgradeYourTrip/commons/UpgradesContainer';
import UpgradesItem from 'app/components/book-trip/UpgradeYourTrip/commons/UpgradeItem';
import { UPGRADE_IDS } from 'app/constants';
import messages from '../messages.intl'
import { getBookingCancellationNotice } from 'app/sagas/selectors'

function CancellationPolicy(props) {
  const cancellationNotice = useSelector(getBookingCancellationNotice)
  const onlyCancelAmenity = props.upgrades.filter(
    (a) => a.id === UPGRADE_IDS.FLEXIBLE_CANCEL_POLICY
  );

  if (!onlyCancelAmenity.length || !cancellationNotice) {
    return null;
  }

  return (
    <>
      <UpgradesItem
        included
        horizontal
        name={<FormattedMessage message={messages.STANDARD_CANCEL_TITLE} />}
        description={
          <FormattedMessage
            message={messages.STANDARD_CANCEL_DESCRIPTION}
            values={{ hours: cancellationNotice }}
          />
        }
        imageUrl="https://static.mozio.com/amenities/bulletproof.svg"
      />
      <UpgradesContainer {...props} upgrades={onlyCancelAmenity} />
    </>
  )
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(CancellationPolicy)
